import axios from "axios";
import router from "./router";
import { FORM_MODE, ROUTE_NAMES, ROUTE_PATHS } from "./router/types";
import { ApiEndpoints, errorWhitelistedEndpoints } from "./static/api-endpoints";
import { config } from "process";
import { useProposalStore } from "./stores/risk/risk";
import { useMainPersistentStore } from "./stores/mainPersistent";
axios.interceptors.response.use(
    function (response) {
        const proposalStore = useProposalStore();
        const retrieveURLS = [ApiEndpoints.GetProposal(proposalStore.proposal.uuid)];
        if (retrieveURLS.includes(response.config.url)) {
            const noRedirectRoutes = [
                FORM_MODE.EDIT,
                ROUTE_NAMES.ThankYou,
                ROUTE_NAMES.Error,
                ROUTE_NAMES.SessionExpired
            ];

            /* check if already paid, redirect to complete if that is the case */
            if (proposalStore.proposal?.quote?.is_purchased && !noRedirectRoutes.includes(router.currentRoute.name)) {
                router
                    .push({
                        name: ROUTE_NAMES.ThankYou,
                        query: router.currentRoute.query
                    })
                    .catch(() => {});
            }
        }

        return response;
    },
    function (error) {
        const status = error.response.status;
        const proposalStore = useProposalStore();
        const mainStorePersistent = useMainPersistentStore();
        const whitelist = errorWhitelistedEndpoints(proposalStore.proposal.uuid);
        const url = error.response.config.url;
        switch (status) {
            case 419:
                // We handle this in session-expired.ts
                break;
            default:
                if (!whitelist.includes(url)) {
                    router.push({ name: ROUTE_NAMES.Error, query: router.currentRoute.query }).catch(() => {});
                }
                break;
        }
        throw error;
    }
);
